import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { SidebarModule } from '../../constants/Enums';
import { TooltipIds } from '../../constants/TooltipIds';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { TooltipStore } from '../../stores/TooltipStore';
import { CoreTooltip } from '../CoreTooltip';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ArticleList } from './articlelist/ArticleList';
import { Catalog } from './catalog/Catalog';
import { PropertyEditor } from './propertyeditor/PropertyEditor';
import { ShareMenu } from './ShareMenu';
import { ShareDL } from './ShareDL';
import { ShareApp } from './ShareApp';
import { ShareMail } from './ShareMail';
import { ShareFormular } from './ShareFormular';
import { SidebarLock } from './SidebarLock';

interface SidebarTabProps {
    layoutType: LayoutType;
    noBars: boolean;
    sidebarOrientation: string;
    showPrices: boolean;
}

interface SidebarTabState {
    activeModul: SidebarModule;
    activeTooltip: TooltipIds | null;
}

export class SidebarTab extends BaseComponent<SidebarTabProps, SidebarTabState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(TooltipStore, this.onChange);
        this.onChange();
    }

    public shouldComponentUpdate(nextProps: SidebarTabProps, nextState: SidebarTabState): boolean {
        return this.state.activeModul !== nextState.activeModul || nextProps !== this.props;
    }

    public render(): JSX.Element {
        const cssStyle: React.CSSProperties = {
            display: ((this.state.activeModul && !this.props.noBars) ? 'block' : 'none')
        };
        let cssClass: string = 'sidebar-tab';
        if (this.props.sidebarOrientation === 'right') {
            cssClass += ' on-right-side';
        }
        return (
            <div style={cssStyle} className={cssClass}>
                <ArticleList
                    visible={this.state.activeModul === SidebarModule.ARTICLELIST}
                    layoutType={this.props.layoutType}
                    showPrices={this.props.showPrices}
                />
                <Catalog
                    visible={this.state.activeModul === SidebarModule.CATALOG}
                    layoutType={this.props.layoutType}
                    rightSide={this.props.sidebarOrientation === 'right'}
                    tooltipElement={(
                        <CoreTooltip
                            config={{
                                label: t('Catalogs'),
                                forceLabel: (this.state.activeTooltip === TooltipIds.CATALOG_FOLDER_ICON ?
                                    t('This will bring you from catalog to catalog faster') : null
                                )
                            }}
                        />
                    )}
                />
                <PropertyEditor
                    visible={this.state.activeModul === SidebarModule.PROPERTIES}
                    layoutType={this.props.layoutType}
                    showPrices={this.props.showPrices}
                />

                <ShareMenu visible={this.state.activeModul === SidebarModule.SHARE} layoutType={this.props.layoutType}/>
                {AppConfigurationStore.shareFormatAvailable('Download') ?
                    <ShareDL visible={this.state.activeModul === SidebarModule.SHARE_DL} layoutType={this.props.layoutType}/> : null
                }
                {AppConfigurationStore.shareFormatAvailable('App') ?
                    <ShareApp visible={this.state.activeModul === SidebarModule.SHARE_APP} layoutType={this.props.layoutType}/> : null
                }
                {AppConfigurationStore.shareFormatAvailable('Mail') ?
                    <ShareMail visible={this.state.activeModul === SidebarModule.SHARE_MAIL} layoutType={this.props.layoutType}/> : null
                }
                {AppConfigurationStore.shareFormatAvailable('Formular') ?
                    <ShareFormular visible={this.state.activeModul === SidebarModule.SHARE_FORMULAR} layoutType={this.props.layoutType}/> : null
                }

                <SidebarLock />
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            activeModul: ViewSettingsStore.getState().sidebar,
            activeTooltip: TooltipStore.getState().activeId
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/SidebarTab.tsx